import { eMessageServices } from "../../services/trading-services/emessage.service"

export const eMessageActions = {
  getEMessageAction,
  deleteEMessageAction,
}

function getEMessageAction(params, callback) {
  return () => {
    return eMessageServices.getEMessageService(params, res => {
      callback(res)
    })
  }
}

function deleteEMessageAction(params, callback) {
  return () => {
    return eMessageServices.deleteEMessageService(params, res => {
      callback(res)
    })
  }
}